var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in", appear: "" } },
    [
      _c(
        "router-link",
        {
          staticClass: "c-residence",
          class: _vm.css,
          attrs: { id: _vm.residence.slug, to: _vm.route, tabindex: "0" },
          nativeOn: {
            mouseover: function($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(true)
            },
            mouseout: function($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(false)
            },
            focus: function($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(true)
            },
            focusout: function($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(false)
            }
          }
        },
        [
          _vm.listType === "cards" &&
          _vm.residence.images.length > 0 &&
          _vm.residence.hasImages === true
            ? _c("card-image", { attrs: { id: _vm.residence.id } })
            : _vm._e(),
          _vm._v(" "),
          _vm.listType === "cards" &&
          _vm.residence.images.length === 0 &&
          _vm.residence.hasImages === true
            ? _c("spinner", { staticClass: "c-spinner c-spinner--card" })
            : _vm._e(),
          _vm._v(" "),
          _vm.listType === "cards" &&
          _vm.residence.images.length === 0 &&
          _vm.residence.hasImages === false
            ? _c("MissingImage")
            : _vm._e(),
          _vm._v(" "),
          _c("header", { staticClass: "c-residence__header" }, [
            _c("h2", { staticClass: "c-residence__name" }, [
              _vm._v("\n        " + _vm._s(_vm.residence.name) + "\n      ")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "c-residence__price" }, [
              _vm._v("\n        " + _vm._s(_vm.priceInfo) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _vm.type || _vm.bedrooms || _vm.size
            ? _c("ul", { staticClass: "c-residence__facts" }, [
                _vm.type
                  ? _c("li", { staticClass: "c-residence__fact" }, [
                      _vm._v("\n        " + _vm._s(_vm.type) + "\n      ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bedrooms
                  ? _c("li", { staticClass: "c-residence__fact" }, [
                      _vm._v("\n        " + _vm._s(_vm.bedrooms) + "\n      ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.size
                  ? _c("li", { staticClass: "c-residence__fact" }, [
                      _vm._v("\n        " + _vm._s(_vm.size) + "\n      ")
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }